<template>
    <div>
        <!-- NYertesek -->
        <div class="bg-primary">
            <div class="container-xl block--big winners py-5" id="nyertesek">
                <div class="row mt-5">  
                    <h2 class="text-center mt-0 text-uppercase text-white my-5">
                        Nyertesek
                    </h2>   
                    <div class="col-12 col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
                        <!-- TAB -->
                        <div class="winners-button-select mb-5 p-1" >
                            <button 
                                class="btn text-white fw-700 text-uppercase" 
                                :style="winnerState === 'hourly' ? 'background: #B8A868;':''" 
                                v-on:click="setWinnerState('hourly')"
                            >
                                Óránkénti <span class="d-none d-md-block ms-1"> nyertesek</span>
                            </button>
                            <button 
                                class="btn text-white text-uppercase fw-700 mx-lg-3" 
                                :style="winnerState === 'daily' ? 'background: #B8A868;':''" 
                                v-on:click="setWinnerState('daily')"
                            >
                                Napi <span class="d-none d-md-block ms-1"> nyertesek</span>
                            </button> 
                            <button 
                                class="btn fw-700 text-white text-uppercase"
                                :style="winnerState === 'weekly' ? 'background: #B8A868;':''" 
                                v-on:click="setWinnerState('weekly')"
                            >
                                Heti <span class="d-none d-md-block ms-1">nyertesek</span>
                            </button>
                        </div>
                        <!-- TABLE -->
                        <div class="winners__border mb-5">
                            <div class="winners__table-wrap winners__table-wrap--heading">                        
                                <table cellspacing="0" cellpadding="0" border="0"  class="winners__block w-100 custom-table"  >
                                    <thead>
                                        <tr class="winners-top font-primary" >
                                            <th class="w-25 text-white text-left">Nyertes neve</th>
                                            <th class="w-25 text-white text-left">Nyertes kód</th>
                                           <!-- <th class="w-25 text-white">Típus</th> -->
                                            <th class="w-25 text-white text-left">Nyeremény</th>                            
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div class="winners__table-wrap winners__table-wrap--bg">                        
                                <table cellspacing="0" cellpadding="0" border="0"  class="winners__block w-100 custom-table"  :class="[`winner-table_${winnerState}`]" >
                                    <tbody v-if="filteredWinners && filteredWinners.length && loginShow">                          
                                        <tr class="winners-list fs-14 text-white font-secondary" v-for="(winner, winnerindex) in filteredWinners" :key="winnerindex">
                                            <td class="winners-id fw-700 text-white text-left w-25 p-3">
                                                <div>{{ winner.name }}</div>                                     
                                            </td>                          
                                            <td class="winners-product text-white text-left w-25 p-3">
                                                <span>{{winner.winning_time}}</span>
                                            </td>
                                            <!--<td class="winners-product text-white text-left  w-25 p-3">
                                                <span>{{winner.winning_type}}</span>
                                            </td>-->
                                            <td class="winners-product text-gold text-left fw-700 text-uppercase  w-25 p-3">
                                                <span v-html="winner.type == 'weekly' ? '168 cm-es Philips TV és egy teli mini sörhűtő': winner.type == 'hourly' ? '1 db tálca Soproni':'1 db Tefal Kontakt Grill'"></span>
                                            </td>
                                        </tr>                            
                                    </tbody>
                                    <tbody v-else>
                                        <tr v-if="loginShow">
                                            <td class="no-winner text-white text-center py-3" colspan="2">
                                                Hamarosan kiderül, kik lettek a nyertesek
                                            </td>                                   
                                        </tr>
                                        <tr v-else>
                                            <td class="no-winner text-center py-3" colspan="2">
                                                A kisorsolt nyertesek részére a nyeremények átadása megtörtént!
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>                        
                            </div>

                            
                        </div>

                        <div class="d-flex justify-content-center py-4" v-if="needMoreBtn">
                                <button target="_blank" type="button" class="btn btn-third" v-on:click="moreWinners(true)">Mutasd a további nyerteseket</button>
                        </div>
                    </div>           
                    
                </div> 
            </div> 
        </div>
        <div class="bg-secondary py-5 text-center">
            <p class="text-white mb-0 py-md-3 mx-2 mx-md-0 font-primary fs-22">Ne feledd, mindenképp őrizd meg a nyitófület vagy kupakot, mert nyerés esetén akár postai úton is bekérhetjük tőled.</p>
        </div>
    </div>
</template>


<script>
export default {
    data () {
        return {
            //winnersAll:[],
            winnerState:'hourly',
            needMoreBtn: false,
            needMoreWinners: false
        }
    },
    computed:{
        filteredWinners() {
            let result = []
            //let _this = this
        
            if(this.$store.state.winnersAll ?? []){                
                
                result = this.$store.state.winnersAll.filter(w => w.type === this.winnerState)

               /* _this.winnersAll.forEach(w => {
                    if (_this.winnerState == 'napi' || _this.winnerState == 'fodij'){
                        if (w.type === this.winnerState){
                            result.push(w)
                        }
                    } else {
                        if (_this.winnerState == 'heti'){
                            if (w.type != 'napi' && w.type != 'fodij'){                            
                                result.push(w)
                            }
                        }
                    }

                })*/

                if(result.length > 10 && !this.needMoreWinners){
                    this.checkBtn(true);
                    return result.slice(0,10);
                }else{
                    this.checkBtn(false);
                    return result;
                }
            }
            this.checkBtn(false);
            return result;
        }
    },
    methods: {
        setWinnerState(newState) {
            this.moreWinners(false); 
            this.winnerState = newState;      
        },
        checkBtn(newState) {
            this.needMoreBtn = newState;
        },
        moreWinners(newState){
            this.needMoreWinners = newState;
        },
        selectWinners(){
            let _this = this
            this.wins.forEach( item => {                
                let winTypeWinners = _this.$store.state.winnersAll.filter( element => element.type == item.type )
                //console.log('winTypeWinners',winTypeWinners)
                if (winTypeWinners)
                    item.winners = winTypeWinners
            })
        }
    },
    created() {
        this.$store.dispatch("getWinners");    
        
    },
  /*  mounted(){
        this.winnersAll = this.$store.state.winnersAll;
    }*/
    
}
</script>